var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 81,
    viewBox: "0 0 86 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12682_2224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.59961,
    y: 2.59961,
    width: 72,
    height: 67,
    rx: 14,
    fill: "url(#paint0_linear_12682_2224)",
    fillOpacity: 0.24,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5996 45.5996C38.8087 45.5996 40.5996 43.8087 40.5996 41.5996C40.5996 39.3905 38.8087 37.5996 36.5996 37.5996C34.3905 37.5996 32.5996 39.3905 32.5996 41.5996C32.5996 43.8087 34.3905 45.5996 36.5996 45.5996Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5996 48.5996C31.2982 47.6681 32.2041 46.9121 33.2455 46.3914C34.2869 45.8707 35.4353 45.5996 36.5996 45.5996C37.7639 45.5996 38.9123 45.8707 39.9537 46.3914C40.9951 46.9121 41.901 47.6681 42.5996 48.5996",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5996 32.5996C38.8087 32.5996 40.5996 30.8087 40.5996 28.5996C40.5996 26.3905 38.8087 24.5996 36.5996 24.5996C34.3905 24.5996 32.5996 26.3905 32.5996 28.5996C32.5996 30.8087 34.3905 32.5996 36.5996 32.5996Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5996 35.5996C31.2982 34.6681 32.2041 33.9121 33.2455 33.3914C34.2869 32.8707 35.4353 32.5996 36.5996 32.5996C37.7639 32.5996 38.9123 32.8707 39.9537 33.3914C40.9951 33.9121 41.901 34.6681 42.5996 35.5996",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5996 45.5996C50.8087 45.5996 52.5996 43.8087 52.5996 41.5996C52.5996 39.3905 50.8087 37.5996 48.5996 37.5996C46.3905 37.5996 44.5996 39.3905 44.5996 41.5996C44.5996 43.8087 46.3905 45.5996 48.5996 45.5996Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5996 48.5996C43.2982 47.6681 44.2041 46.9121 45.2455 46.3914C46.2869 45.8707 47.4353 45.5996 48.5996 45.5996C49.7639 45.5996 50.9123 45.8707 51.9537 46.3914C52.9951 46.9121 53.901 47.6681 54.5996 48.5996",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5996 32.5996C50.8087 32.5996 52.5996 30.8087 52.5996 28.5996C52.5996 26.3905 50.8087 24.5996 48.5996 24.5996C46.3905 24.5996 44.5996 26.3905 44.5996 28.5996C44.5996 30.8087 46.3905 32.5996 48.5996 32.5996Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5996 35.5996C43.2982 34.6681 44.2041 33.9121 45.2455 33.3914C46.2869 32.8707 47.4353 32.5996 48.5996 32.5996C49.7639 32.5996 50.9123 32.8707 51.9537 33.3914C52.9951 33.9121 53.901 34.6681 54.5996 35.5996",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12682_2224",
    x: -0.00039053,
    y: -0.00039053,
    width: 85.2,
    height: 80.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.929412 0 0 0 0 0.796078 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12682_2224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12682_2224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12682_2224",
    x1: 12.0996,
    y1: 2.59961,
    x2: 82.5996,
    y2: 80.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryTypeIcon);
export default __webpack_public_path__ + "static/media/inventory_type_icon.058d201a06c5a1c26458fff1ecceedd5.svg";
export { ForwardRef as ReactComponent };